import { HttpStatusCodes } from 'app/shared/http-status-codes';
import { UiError } from './ui-error';

export class UiConflictError extends UiError {
  public readonly fields: string[];

  public constructor(fields: string[]) {
    super('The item being added conflicts with an existing item', HttpStatusCodes.Conflict);
    this.fields = fields;
  }
}
